<template>
  <Modal :title="title" v-model="visible" :mask-closable="false" width="450px" class="my-modal">
    <loading :isShow="loading" />
    <Form v-if="visible" ref="myForm" :model="formData" class="modal-form" @submit.native.prevent>
      <FormItem prop="name" :rules="$units.formRule.required('请输入')">
        <Input v-model="formData.name" placeholder="请输入栏目名称" clearable />
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="primary" ghost @click="visible = false">取消</Button>
      <Button type="primary" @click="submit">确定</Button>
    </div>
  </Modal>
</template>
<script>
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  data: () => ({
    visible: false,
    loading: false,
    title: '',
    formData: {
      name: ''
    }
  }),
  components: {},
  created() {},
  methods: {
    open(data) {
      if (data.id) {
        this.title = '编辑栏目';
      } else {
        this.title = '新增栏目';
      }
      this.formData = JSON.parse(JSON.stringify(data));
      this.visible = true;
      this.clearValidate();
    },
    submit() {
      this.$refs.myForm.validate(valid => {
        if (valid) {
          if(this.loading) {
            return;
          }
          this.loading = true;
          this.$http({
            url: '/buz/exhibitionPicConfigType/addSellCardType',
            type: 'POST',
            data: this.formData
          }).then(res => {
            this.visible = false;
            this.$emit('reload');
            this.$notice.success('提交成功');
          }).finally(()=>{
            window.setTimeout(()=>{
              this.loading = false;
            }, 300)
          });
        }
      });
    }
  }
};
</script>
<style lang='scss' scoped>
</style>